const ThingsModel = {
    "languages & Tools":[
        {
            name:"html5",
            link:"TID-img/html.jpg"
        },
        {
            name: "CSS",
            link:"TID-img/css.jpg"
        },
        {
            name: "Java",
            link: "TID-img/java.jpg"
        },
        {
            name: "Java Script",
            link: "TID-img/javascript.jpg"
        },
        {
            name: "Python",
            link: "TID-img/python.jpg"
        },
        {
            name:"git",
            link:"TID-img/git.jpg"
        },
        {
            name: "Android Studio",
            link: "TID-img/android.jpg"
        },
        {
            name : "VS Code",
            link:"TID-img/vscode.jpg"
        },
        {
            name: "Canva",
            link:"TID-img/canva.jpg"
        },
        {
            name : "Postman",
            link:"TID-img/postman.jpg"
        },
    ],
    "frameworks & Consoles":[
        {
            name : "Bootstrap",
            link:"TID-img/bootstrap.jpg"
        },
        {
            name:"Nodejs",
            link:"TID-img/node.jpg"
        },
        {
            name: "OpenCV",
            link: "TID-img/opencv.jpg"
        },
        {
            name:"React",
            link:"TID-img/react.jpg"
        },
        {
            name : "MS Office",
            link:"TID-img/msoffice.jpg"
        },
        {
            name : "npm",
            link:"TID-img/npm.png"
        },
        {
            name : "firebase",
            link:"TID-img/firebase.jpg"
        },
        {
            name: "Netlify",
            link:"TID-img/netlify.jpg"
        },
        {
            name:"GitHub",
            link:"TID-img/github.jpg"
        },
        {
            name:"AWS",
            link:"TID-img/aws.jpg"
        },
        {
            name:"MongoDB",
            link:"TID-img/mongodb.jpg"
        },
        {
            name:"Realm DB",
            link:"TID-img/realmdb.jpg"
        },
        {
            name:"MySQL DB",
            link:"TID-img/mysql.jpg"
        },
        {
            name:"DynamoDB",
            link:"TID-img/dynamo.jpg"
        }
    ]
}

export default ThingsModel